import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import client, { formatApiError } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

const when = (v) => (v ? new Date(v).toLocaleString() : "");

export function AlertsSection() {
  const [d, setD] = useState(null);
  const load = () => client.get("/account/notifications").then((r) => setD(r.data));
  useEffect(() => { load().then(() => client.post("/account/notifications/read")); }, []);
  const save = async (k, v) => {
    const prefs = { ...d.prefs, [k]: v };
    try { await client.put("/account/notification-prefs", prefs); setD({ ...d, prefs }); toast.success("Alert preferences saved"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  if (!d) return null;
  return (
    <div className="space-y-8" data-testid="alerts-section">
      <div className="rounded-2xl border border-white/10 p-5 space-y-4">
        <p className="font-semibold">Conviction alerts</p>
        <p className="text-xs text-zinc-500">Sent when a conviction you have access to gets an analyst signal or reaches a target or cut loss. Model results are simulated, not real trades.</p>
        {[["conviction_email", "Email alerts"], ["conviction_inapp", "In-app alerts"]].map(([k, l]) => (
          <label key={k} className="flex items-center justify-between text-sm">{l}
            <Switch data-testid={`pref-${k}`} checked={d.prefs[k]} onCheckedChange={(v) => save(k, v)} /></label>
        ))}
      </div>
      <div data-testid="alerts-list">
        <p className="font-semibold mb-3">Recent alerts</p>
        {d.items.length === 0 && <p className="text-sm text-zinc-500" data-testid="alerts-empty">No alerts yet.</p>}
        <ul className="space-y-3">{d.items.map((n) => (
          <li key={n.id} data-testid={`alert-${n.id}`} className="rounded-xl border border-white/10 p-4">
            <Link to={n.link} className="font-semibold text-sm hover:text-[#ccff00]">{n.title}</Link>
            {!n.read_at && <span className="ml-2 text-[10px] text-[#ccff00] font-mono-cl uppercase">new</span>}
            <p className="text-xs text-zinc-400 mt-1">{n.body}</p>
            <p className="text-[11px] text-zinc-600 mt-1">{when(n.created_at)}{n.simulated ? " · simulated model" : ""}</p>
          </li>))}</ul>
      </div>
    </div>
  );
}
